export default __webpack_public_path__ + "static/media/wi_03n_scattered_clouds.1597ff03.svg";